import { FC } from 'react'
import { StyleSheet, View } from 'react-native'
import { Text, TouchableRipple } from 'react-native-paper'
import { SvgProps } from 'react-native-svg'
import { isWeb } from '../../../constants/platform'

interface BarButtonWithIconProps {
    children: string
    color: string
    fontSize?: number
    onPress: () => void
    Icon: FC<SvgProps>
}

const BarButtonWithIcon: FC<BarButtonWithIconProps> = ({
    children,
    color,
    fontSize = 16,
    onPress,
    Icon,
}) => {
    return (
        <TouchableRipple onPress={onPress}>
            <View style={styles.container}>
                <Icon fill={color} style={styles.icon} viewBox="0 0 17 17" />
                <Text style={[styles.text, { color, fontSize }]}>{children}</Text>
            </View>
        </TouchableRipple>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        height: '100%',
        paddingHorizontal: 6,
    },
    icon: isWeb ? { marginLeft: 2, marginRight: 2 } : { marginHorizontal: 2 },
    text: {
        marginHorizontal: 2,
        fontWeight: 'bold',
    },
})

export default BarButtonWithIcon
